import { render, staticRenderFns } from "./fixed-assets-mgmnt.vue?vue&type=template&id=c2baafd8"
import script from "./fixed-assets-mgmnt.vue?vue&type=script&lang=js"
export * from "./fixed-assets-mgmnt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports